<template>
  <div class="date-picker-with-suggestions">
    <a-button-group class="margin-bottom">
      <a-tooltip v-for="suggestion in suggestions" :key="suggestion.description">
        <template v-slot="title">
          {{ suggestion.description }} ({{ dateForHumans(getMoment(suggestion.amount, suggestion.unit)) }})
        </template>
        <a-button :disabled="disabled"
                  @click="setDate(getMoment(suggestion.amount, suggestion.unit))"
                  :type="isPrimary(getMoment(suggestion.amount, suggestion.unit))">
          {{ suggestion.description }}
        </a-button>
      </a-tooltip>
    </a-button-group>

    <a-date-picker
        :value="selectedDate"
        :locale="locale"
        :allowClear="allowClear"
        :format="datePickerFormat"
        :disabled="disabled"
        @change="setDate"
        style="width: 100%"
    />
    <input type="hidden" :name="name" :value="dateString"/>

  </div>
</template>

<script>
import moment from 'moment';
import locale from 'ant-design-vue/es/date-picker/locale/nl_NL';
import 'moment/locale/nl';
import DateFormatEnum from '~/enums/DateFormatEnum';

export default {
  props: {
    name: {
      type: String,
      required: false,
    },
    value: {
      type: [String, Number],
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: DateFormatEnum.ISO8601,
    },
    allowClear: {
      type: Boolean,
      default: false,
    },
    nullableDate: {
      type: Boolean,
      default: false,
    },
    datePickerFormat: {
      type: String,
      default: DateFormatEnum.DISPLAY_DATE,
    },
    suggestions: {
      type: Array,
      validator: (array) => {
        return array.every(object => 'description' in object && 'amount' in object && 'unit' in object)
      },
      default: () => {
        return [
          {
            description: 'Vandaag',
            amount: 0,
            unit: 'days'
          }, {
            description: 'Morgen',
            amount: 1,
            unit: 'days'
          }, {
            description: '1 week',
            amount: 1,
            unit: 'weeks'
          }, {
            description: '2 weken',
            amount: 2,
            unit: 'weeks'
          }, {
            description: '3 weken',
            amount: 3,
            unit: 'weeks'
          }, {
            description: '1 maand',
            amount: 1,
            unit: 'months'
          }, {
            description: '1 jaar',
            amount: 1,
            unit: 'years'
          }, {
            description: '3 jaar',
            amount: 3,
            unit: 'years'
          }, {
            description: '5 jaar',
            amount: 5,
            unit: 'years'
          }
        ]
      }
    }
  },
  name: "DatePickerWithSuggestions",
  data() {
    return {
      locale,
      moment,
      selectedDate: '',
    }
  },
  mounted() {
    if (!this.nullableDate || this.value) {
      let propsValue = moment(this.value, DateFormatEnum.ISO8601).isValid()
          ? moment(this.value, DateFormatEnum.ISO8601)
          : moment().add(1, 'days');
      this.setDate(propsValue);
    }
  },
  computed: {
    dateString() {
      return this.selectedDate === null ? '' : moment(this.selectedDate).format(this.format);
    },
  },
  methods: {
    getMoment(amount, unit) {
      return moment().add(amount, unit);
    },
    dateForHumans(date) {
      return moment(date, moment.ISO_8601).format(DateFormatEnum.DISPLAY_DATE);
    },
    setDate(date) {
      this.selectedDate = date;
      this.$emit('change', this.selectedDate);
    },
    isPrimary(date) {
      return this.dateForHumans(this.selectedDate) === this.dateForHumans(date) ? 'primary' : '';
    },
  },
  watch: {
    value() {
      let propsValue = moment(this.value, DateFormatEnum.ISO8601).isValid()
          ? moment(this.value, DateFormatEnum.ISO8601)
          : this.nullableDate ? null : moment().add(1, 'days');
      this.setDate(propsValue);
    }
  }
}
</script>

<style scoped>
.margin-bottom {
  margin-bottom: 5px;
}

.date-picker-with-suggestions {
  display: inline-block;
  width: 100%;
}
</style>